// extracted by mini-css-extract-plugin
export default {"VoiceSettingsSlider":"voisesettingsslider_VoiceSettingsSlider__SjmRC"};